export default __webpack_public_path__ + "static/media/icon_last.69af6598.svg";